import axios from 'axios';
import { LoadingStates } from 'shared/constants/loadingStates';
import _ from 'lodash';
import { clearForm } from 'plantItemNew/redux/slices/formSlice';
import { PLANT_API_BASE_URL } from 'shared/constants/constants';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const initialState = {
  data: null,
  status: 'idle',
  error: null,
};

const plantDesignLicenceTypesSlice = createSlice({
  name: 'plantDesignLicence',
  initialState,
  reducers: {
    clearPlantDesignLicenceTypes() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlantDesignLicenceTypes.pending, (state, action) => {
        state.status = LoadingStates.Loading;
      })
      .addCase(getPlantDesignLicenceTypes.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = LoadingStates.Succeeded;
      })
      .addCase(getPlantDesignLicenceTypes.rejected, (state, action) => {
        state.status = LoadingStates.Rejected;
        state.status = action.error.message;
      })
      .addCase(clearForm, () => {
        return initialState;
      });
  },
});

const apiUrl = `${PLANT_API_BASE_URL}/design/licences`;

export const getPlantDesignLicenceTypes = createAsyncThunk(
  'plantDesignLicence/getLicenceTypes',
  async () => {
    const res = await axios.get(apiUrl, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return res.data.response;
  },
  {
    condition: (arg, { getState }) => {
      const { plantDesignLicenceTypes } = getState();
      return _.isEmpty(plantDesignLicenceTypes.data) && plantDesignLicenceTypes.status !== LoadingStates.Loading;
    },
  },
);

export const { clearPlantDesignLicenceTypes } = plantDesignLicenceTypesSlice.actions;
export const plantDesignLicenceTypesReducer = plantDesignLicenceTypesSlice.reducer;
